import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { api_urls } from "../../utils/api-urls/index.js";
import * as SubCategoryActions from '../../redux/actions/subCategoryAction.js';
import MainDatatable from "../../components/common/MainDatatable.jsx";
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { DeleteSvg, EditSvg, FilterSvg, SwitchOffSvg, SwitchOnSvg, ViewSvg } from "../../assets/svg/index.js";

const SubCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subCategoryData } = useSelector(state => state.subCategoryReducer)

  //! Handle Filter 
  const [filterText, setfilterText] = useState('');
  const uniqueRedirectPage = Array.from(new Set(subCategoryData.map(item => item.redirect_page)));
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpenFilterDropDown = (event) => { setAnchorEl(event.currentTarget) };
  const handleCloseFilterDropDown = () => { setAnchorEl(null) };

  const handleFilter = (data) => {
    setfilterText(data)
    handleCloseFilterDropDown()
  };

  let filteredData;
  if (filterText.toLowerCase() === "all") {
    filteredData = subCategoryData;
  } else {
    filteredData = subCategoryData && subCategoryData.filter(item =>
      Object.values(item).some(value =>
        value && value?.toString().toLowerCase().includes(filterText?.toLowerCase())
      )
    );
  }

  //* Sub Category DataTable Columns
  const subCategoryColumns = [
    { name: 'S.No.', selector: row => filteredData.length - filteredData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
    { name: 'Category Name', selector: row => row?.categoryId?.category_name },
    { name: 'Sub Category Name', selector: row => row?.sub_category_name },
    { name: <div onClick={handleOpenFilterDropDown} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}><span>Redirect Page</span>  <FilterSvg h={'16'} /></div>, selector: row => row?.redirect_page },
    { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
    { name: 'Status', selector: row => <div onClick={() => dispatch(SubCategoryActions?.changeSubCategoryStatus({ subCategoryId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        <div onClick={() => navigate('/sub-category/edit-sub-category', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
        <div onClick={() => dispatch(SubCategoryActions.deleteSubCategory({ subCategoryId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div >,
      width: "180px"
    },
  ];

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    dispatch(SubCategoryActions.getSubCategory());
  }, []);

  return (
    <>
      <MainDatatable data={filteredData} columns={subCategoryColumns} title={'Sub Category'} url={'/sub-category/add-sub-category'} />

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseFilterDropDown} >
        <MenuItem style={{ width: "100px" }} onClick={() => handleFilter('all')}>All</MenuItem>
        {uniqueRedirectPage?.map((value, index) => (
          <MenuItem key={index} style={{ width: "100px" }} onClick={() => handleFilter(value)}>{value}</MenuItem>
        ))}
      </Menu>
    </ >
  );
}

export default SubCategory;